let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("a6Gnx")).then(() => parcelRequire('8SgbI'));